import './App.css';
export default function InfoOstanView({ error, province_name, province_id }) {
    // اگر نه خطایی وجود دارد و نه اسمی، چیزی رندر نشود
    if (!error && !province_name) return null;

    return (
        // استفاده از Fragment یا یک div اصلی برای در بر گرفتن کل خروجی
        <div style={{ direction: 'rtl', fontFamily: 'tahoma, arial' }}>

            {/* نمایش پیام خطا */}
            {error && (
                <p className='cardError'>
                    {error}
                </p>
            )}

            {/* نمایش کارت اطلاعات استان */}
            {province_name && (
                <div className='cardostantitle'>
                    <div className='cardOstanInfo'>
                        <span style={{ fontSize: '20px' }}>📍</span>
                        <span style={{ fontWeight: 'bold', color: '#333' }}>اطلاعات مکان:</span>
                    </div>

                    <div style={{ marginBottom: '10px', color: '#555' }}>
                        <span style={{ color: '#888', fontSize: '0.9em' }}>نام استان: </span>
                        <strong style={{ color: '#2c3e50', fontSize: '1.1em' }}>{province_name}</strong>
                    </div>

                    <div style={{ color: '#555' }}>
                        <span style={{ color: '#888', fontSize: '0.9em' }}>شناسه استان: </span>
                        <code className='cardostanid'>
                            {province_id}
                        </code>
                    </div>
                </div>
            )}
        </div>
    );
}
